export default __webpack_public_path__ + "static/media/Standard12.8ff7ed32.png";